import { memo } from 'react'
import SvgCalendarIcon from '../../icons/common/svgCalendar'
import { DatePickerCalendarIconProps } from '../../utils/types'

export const DatePickerCalendarIcon = memo(function DatePickerCalendarIcon({
  uniqueString,
  isDisabled,
  onToggle,
  className = '',
}: DatePickerCalendarIconProps) {
  const disabledClass = isDisabled
    ? 'cursor-not-allowed opacity-50'
    : 'cursor-pointer'

  return (
    <div
      className={`react-datepicker__calendar-icon !absolute !right-[0.225rem] !top-1/2 !-translate-y-1/2 !box-content !w-4 !h-4 !p-0 z-[1] flex items-center justify-center bg-white custom-datepicker-icon-${uniqueString} ${disabledClass} ${className}`}
      onClick={(e) => {
        e?.stopPropagation()
        e?.preventDefault()
        if (!isDisabled) {
          onToggle()
        }
      }}
    >
      <SvgCalendarIcon className={disabledClass} />
    </div>
  )
})
